var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wrapper",
    [
      _vm.modal.isVisible("deleteOrg")
        ? _c(
            "modal",
            {
              attrs: {
                title: "Delete " + _vm.organisation.name,
                "show-footer": false
              },
              on: {
                close: function($event) {
                  _vm.modal.hide("deleteOrg")
                  _vm.deletionString = null
                }
              }
            },
            [
              _c("p", { staticClass: "text-danger lead" }, [
                _vm._v("This school will be permanently deleted. "),
                _c("br"),
                _vm._v(" This action is irreversible.")
              ]),
              _c("div", { staticClass: "input-group width-100" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.deletionString,
                      expression: "deletionString"
                    }
                  ],
                  staticClass: "form-control width-100",
                  attrs: {
                    name: "name",
                    placeholder:
                      "Enter '" + _vm.organisation.name + "' to confirm",
                    type: "text",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.deletionString },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.deletionString = $event.target.value
                    }
                  }
                })
              ]),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _vm._t("footer"),
                  _c(
                    "loading-button",
                    {
                      staticClass: "btn btn-warning",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.modal.hide("deleteOrg")
                          _vm.deletionString = null
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "loading-button",
                    {
                      staticClass: "btn btn-primary btn-danger",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        disabled: _vm.deletionString !== _vm.organisation.name
                      },
                      on: { click: _vm.deleteOrg }
                    },
                    [_vm._v("Delete Permanently")]
                  )
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm.organisation
        ? _c("div", { staticClass: "challenge-organisation-page" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "box box-info mb-6" }, [
                  _c("div", { staticClass: "box-body" }, [
                    !_vm.isEditingSchool
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c("th", [_vm._v("Contact")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.organisation.contact_name) +
                                    " (" +
                                    _vm._s(_vm.organisation.contact_job_role) +
                                    ")"
                                ),
                                _c("br"),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:" + _vm.organisation.email
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.organisation.email))]
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("Challenge Code")]),
                              _c("td", [_vm._v(_vm._s(_vm.organisation.code))])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("Governance")]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.governanceDescription))
                              ])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("Phase of Education")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.educationPhases[
                                      _vm.organisation.education_phase
                                    ] || "Not set"
                                  )
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("Region")]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.organisation.region))
                              ])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("City")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.organisation.city || "Not set")
                                )
                              ])
                            ]),
                            _vm.organisation.english_hub
                              ? _c("tr", [
                                  _c("th", [_vm._v("English Hub")]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.organisation.english_hub.name
                                        ) +
                                        " "
                                    ),
                                    _vm.organisation.english_hub.is_referral
                                      ? _c(
                                          "span",
                                          { staticClass: "label label-info" },
                                          [_vm._v("referral")]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e(),
                            _c("tr", [
                              _c("th", [_vm._v("PURL")]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.organisation.joining_url))
                              ])
                            ]),
                            _vm.organisation.enterprise
                              ? _c("tr", [
                                  _c("th", [_vm._v("Fonetti School")]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "School",
                                              params: {
                                                schoolId:
                                                  _vm.organisation.enterprise.id
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.organisation.enterprise.name
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm.isEditingSchool
                      ? _c("div", [
                          _c(
                            "form",
                            {
                              staticClass: "form-horizontal school-form",
                              attrs: { action: "#" },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.validateEditSchoolForm($event)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("name")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "name" }
                                    },
                                    [_vm._v("School Name")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.organisationEditable.name,
                                          expression:
                                            "organisationEditable.name"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "name",
                                        id: "name",
                                        autocomplete: "off"
                                      },
                                      domProps: {
                                        value: _vm.organisationEditable.name
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("name"),
                                          expression: "errors.has('name')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("name")) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first(
                                      "contact_name"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "contact_name" }
                                    },
                                    [_vm._v("Contact Name")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.organisationEditable
                                              .contact_name,
                                          expression:
                                            "organisationEditable.contact_name"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "contact_name",
                                        id: "contact_name",
                                        autocomplete: "off"
                                      },
                                      domProps: {
                                        value:
                                          _vm.organisationEditable.contact_name
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "contact_name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("contact_name"),
                                          expression:
                                            "errors.has('contact_name')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first("contact_name")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first(
                                      "contact_job_role"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "contact_job_role" }
                                    },
                                    [_vm._v("Contact Job Role")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.organisationEditable
                                              .contact_job_role,
                                          expression:
                                            "organisationEditable.contact_job_role"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "contact_job_role",
                                        id: "contact_job_role",
                                        autocomplete: "off"
                                      },
                                      domProps: {
                                        value:
                                          _vm.organisationEditable
                                            .contact_job_role
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "contact_job_role",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "contact_job_role"
                                          ),
                                          expression:
                                            "errors.has('contact_job_role')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first("contact_job_role")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("email")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "email" }
                                    },
                                    [_vm._v("Contact Email")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.organisationEditable.email,
                                          expression:
                                            "organisationEditable.email"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            email: true
                                          },
                                          expression:
                                            "{ required: true, email: true }"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "email",
                                        id: "email",
                                        autocomplete: "off"
                                      },
                                      domProps: {
                                        value: _vm.organisationEditable.email
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "email",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("email"),
                                          expression: "errors.has('email')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("email")) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("country")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "country" }
                                    },
                                    [_vm._v("Country")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.organisationEditable.country,
                                            expression:
                                              "organisationEditable.country"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "country",
                                          id: "country",
                                          autocomplete: "off",
                                          "data-vv-as": "Country"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.organisationEditable,
                                              "country",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.countries, function(country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country["id"],
                                            domProps: { value: country["id"] }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(country["name"])
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("country"),
                                          expression: "errors.has('country')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("country")) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("postcode")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "region" }
                                    },
                                    [_vm._v("Postcode")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.organisationEditable.postcode,
                                            expression:
                                              "organisationEditable.postcode"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          name: "postcode",
                                          id: "postcode",
                                          autocomplete: "off",
                                          "data-vv-as": "postcode"
                                        },
                                        domProps: {
                                          value:
                                            _vm.organisationEditable.postcode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.organisationEditable,
                                              "postcode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "input-group-btn" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-default",
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  _vm.isLookingUpPostcode ||
                                                  !_vm.organisationEditable
                                                    .postcode
                                              },
                                              on: { click: _vm.lookupPostcode }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.isLookingUpPostcode
                                                      ? "Looking up..."
                                                      : "Look up"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("postcode"),
                                          expression: "errors.has('postcode')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("postcode")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.postcodeNeedsLookup,
                                          expression: "postcodeNeedsLookup"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block text-warning"
                                    },
                                    [
                                      _vm._v(
                                        " Postcode changed. Region and City have not been re-checked; press Look up to refresh them, or edit them by hand. "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("region")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "region" }
                                    },
                                    [_vm._v("Region")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _vm.regions.length > 0
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.organisationEditable
                                                    .region,
                                                expression:
                                                  "organisationEditable.region"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "region",
                                              id: "region",
                                              autocomplete: "off",
                                              "data-vv-as": "Region"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.organisationEditable,
                                                  "region",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          _vm._l(_vm.regions, function(
                                            group,
                                            key
                                          ) {
                                            return _c(
                                              "optgroup",
                                              {
                                                key: key,
                                                attrs: {
                                                  label:
                                                    group["group_name"] != ""
                                                      ? group["group_name"]
                                                      : "Chose a region"
                                                }
                                              },
                                              _vm._l(group["values"], function(
                                                region,
                                                k
                                              ) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: k,
                                                    domProps: { value: region }
                                                  },
                                                  [_vm._v(_vm._s(region))]
                                                )
                                              }),
                                              0
                                            )
                                          }),
                                          0
                                        )
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.organisationEditable.region,
                                              expression:
                                                "organisationEditable.region"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            name: "region",
                                            id: "region",
                                            autocomplete: "off",
                                            "data-vv-as": "region"
                                          },
                                          domProps: {
                                            value:
                                              _vm.organisationEditable.region
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.organisationEditable,
                                                "region",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("region"),
                                          expression: "errors.has('region')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("region")) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("city")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("City")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.organisationEditable.city,
                                          expression:
                                            "organisationEditable.city"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "city",
                                        id: "city",
                                        autocomplete: "off",
                                        "data-vv-as": "city"
                                      },
                                      domProps: {
                                        value: _vm.organisationEditable.city
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "city",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("city"),
                                          expression: "errors.has('city')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.errors.first("city")) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first("school_type")
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "school_type" }
                                    },
                                    [_vm._v("School Type")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.organisationEditable
                                                .school_type,
                                            expression:
                                              "organisationEditable.school_type"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "school_type",
                                          id: "school_type",
                                          autocomplete: "off",
                                          "data-vv-as": "School Type"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.organisationEditable,
                                              "school_type",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.schoolTypes, function(v, k) {
                                        return _c(
                                          "option",
                                          { key: k, domProps: { value: k } },
                                          [_vm._v(_vm._s(v))]
                                        )
                                      }),
                                      0
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("school_type"),
                                          expression:
                                            "errors.has('school_type')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first("school_type")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first(
                                      "education_phase"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "education_phase" }
                                    },
                                    [_vm._v("Phase of Education")]
                                  ),
                                  _c("div", { staticClass: "col-sm-10" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.organisationEditable
                                                .education_phase,
                                            expression:
                                              "organisationEditable.education_phase"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "education_phase",
                                          id: "education_phase",
                                          autocomplete: "off",
                                          "data-vv-as": "Phase of Education"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.organisationEditable,
                                              "education_phase",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: null } },
                                          [_vm._v("Not set")]
                                        ),
                                        _vm._l(_vm.educationPhases, function(
                                          label,
                                          value
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: value,
                                              domProps: { value: value }
                                            },
                                            [_vm._v(_vm._s(label))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "education_phase"
                                          ),
                                          expression:
                                            "errors.has('education_phase')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first("education_phase")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              ["la", "mat"].includes(
                                _vm.organisationEditable.school_type
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      class: {
                                        "has-error": _vm.errors.first(
                                          "school_governed_by_name"
                                        )
                                      }
                                    },
                                    [
                                      _c("label", {
                                        staticClass: "col-sm-2 control-label",
                                        attrs: {
                                          for: "school_governed_by_name"
                                        },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.organisationEditable
                                              .school_type == "la"
                                              ? "Which Local Authority?"
                                              : "Which MAT?"
                                          )
                                        }
                                      }),
                                      _c("div", { staticClass: "col-sm-10" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.organisationEditable
                                                  .school_governed_by_name,
                                              expression:
                                                "organisationEditable.school_governed_by_name"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            name: "school_governed_by_name",
                                            id: "school_governed_by_name",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value:
                                              _vm.organisationEditable
                                                .school_governed_by_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.organisationEditable,
                                                "school_governed_by_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "school_governed_by_name"
                                              ),
                                              expression:
                                                "errors.has('school_governed_by_name')"
                                            }
                                          ],
                                          staticClass:
                                            "col-sm-10 col-sm-offset-2 help-block is-danger"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "school_governed_by_name"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2 control-label",
                                    attrs: { for: "english_hub" }
                                  },
                                  [_vm._v("English Hub")]
                                ),
                                _c("div", { staticClass: "col-sm-10" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.organisationEditable
                                              .english_hub_slug,
                                          expression:
                                            "organisationEditable.english_hub_slug"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        name: "english_hub",
                                        id: "english_hub"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.organisationEditable,
                                            "english_hub_slug",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("None")]
                                      ),
                                      _vm._l(_vm.englishHubs, function(hub) {
                                        return _c(
                                          "option",
                                          {
                                            key: hub.slug,
                                            domProps: { value: hub.slug }
                                          },
                                          [_vm._v(_vm._s(hub.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ])
                              ]),
                              _vm.organisationEditable.english_hub_slug
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-sm-10 col-sm-offset-2"
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.organisationEditable
                                                    .english_hub_is_referral,
                                                expression:
                                                  "organisationEditable.english_hub_is_referral"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.organisationEditable
                                                  .english_hub_is_referral
                                              )
                                                ? _vm._i(
                                                    _vm.organisationEditable
                                                      .english_hub_is_referral,
                                                    null
                                                  ) > -1
                                                : _vm.organisationEditable
                                                    .english_hub_is_referral
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.organisationEditable
                                                      .english_hub_is_referral,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.organisationEditable,
                                                        "english_hub_is_referral",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.organisationEditable,
                                                        "english_hub_is_referral",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.organisationEditable,
                                                    "english_hub_is_referral",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " This hub referred the school "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "has-error": _vm.errors.first(
                                      "enterprise_id"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-2 control-label",
                                      attrs: { for: "enterprise_id" }
                                    },
                                    [_vm._v("Fonetti School")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-10" },
                                    [
                                      _c("vue-tags-input", {
                                        attrs: {
                                          id: "enterprise_id",
                                          addOnlyFromAutocomplete: true,
                                          placeholder: "Select a school",
                                          "autocomplete-items":
                                            _vm.filteredFonettiSchools,
                                          "autocomplete-min-length": 0,
                                          "max-tags": 1,
                                          tags: _vm.selectedFonettiSchool
                                        },
                                        on: {
                                          "tags-changed": function(newTags) {
                                            return (_vm.selectedFonettiSchool = newTags)
                                          }
                                        },
                                        model: {
                                          value: _vm.fonettiSchoolSearchString,
                                          callback: function($$v) {
                                            _vm.fonettiSchoolSearchString = $$v
                                          },
                                          expression:
                                            "fonettiSchoolSearchString"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "enterprise_id"
                                          ),
                                          expression:
                                            "errors.has('enterprise_id')"
                                        }
                                      ],
                                      staticClass:
                                        "col-sm-10 col-sm-offset-2 help-block is-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first("enterprise_id")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "box-footer" },
                                [
                                  _c(
                                    "loading-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        isLoading: _vm.isSavingSchool
                                      }
                                    },
                                    [_vm._v("Save")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _c("div", { staticClass: "box box-info mb-6" }, [
                  _c("div", { staticClass: "box-body" }, [
                    _c(
                      "div",
                      { staticClass: "asset-header" },
                      [
                        _c("span", { staticClass: "asset-status" }, [
                          _vm._v(" Asset generation status: "),
                          _c(
                            "span",
                            {
                              staticClass: "asset-status__badge",
                              class: "asset-status__badge--" + _vm.assetStatus
                            },
                            [
                              _vm.assetStatus === "generating"
                                ? _c("i", {
                                    staticClass: "fa fa-spinner fa-spin"
                                  })
                                : _vm._e(),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.organisation.assets_generation_status
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c(
                          "loading-button",
                          {
                            staticClass: "btn-success btn-sm",
                            attrs: { isLoading: _vm.isRegenerating },
                            on: { click: _vm.forceRegenAssets }
                          },
                          [_vm._v("Force Regenerate")]
                        )
                      ],
                      1
                    ),
                    _vm.assetGroups.length === 0
                      ? _c("p", { staticClass: "asset-empty" }, [
                          _vm._v("No assets generated yet.")
                        ])
                      : _c(
                          "div",
                          { staticClass: "asset-list" },
                          _vm._l(_vm.assetGroups, function(group) {
                            return _c(
                              "div",
                              {
                                key: group.name,
                                staticClass: "asset-row",
                                class: { "asset-row--nested": group.nested }
                              },
                              [
                                _c("span", { staticClass: "asset-row__name" }, [
                                  _vm._v(_vm._s(group.name))
                                ]),
                                !group.nested
                                  ? _c(
                                      "span",
                                      { staticClass: "asset-row__links" },
                                      _vm._l(group.subgroups[0].items, function(
                                        item,
                                        i
                                      ) {
                                        return _c(
                                          "a",
                                          {
                                            key: i,
                                            staticClass: "asset-link",
                                            class:
                                              "asset-link--" +
                                              item.type.toLowerCase(),
                                            attrs: {
                                              href: item.url,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa",
                                              class: item.icon
                                            }),
                                            _vm._v(
                                              " " + _vm._s(item.type) + " "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "asset-row__subrows" },
                                      _vm._l(group.subgroups, function(sub) {
                                        return _c(
                                          "div",
                                          {
                                            key: sub.label,
                                            staticClass: "asset-subrow"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "asset-subrow__label"
                                              },
                                              [_vm._v(_vm._s(sub.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "asset-subrow__links"
                                              },
                                              _vm._l(sub.items, function(
                                                item,
                                                i
                                              ) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: i,
                                                    staticClass: "asset-link",
                                                    class:
                                                      "asset-link--" +
                                                      item.type.toLowerCase(),
                                                    attrs: {
                                                      href: item.url,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa",
                                                      class: item.icon
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.type) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                              ]
                            )
                          }),
                          0
                        )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "flex justify-content-end column-gap-3" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.startEditingSchool }
                      },
                      [_vm._v("Edit School Info")]
                    ),
                    _c("confirmation-button", {
                      attrs: {
                        "show-modal":
                          _vm.showConfirmationModal["reset-password"],
                        "hide-modal-footer": true
                      },
                      on: {
                        close: function($event) {
                          _vm.showConfirmationModal["reset-password"] = false
                        },
                        click: _vm.handleResetPassword
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button",
                            fn: function() {
                              return [_vm._v("Reset password")]
                            },
                            proxy: true
                          },
                          {
                            key: "modal",
                            fn: function() {
                              return [
                                null === _vm.newPassword
                                  ? _c("div", [
                                      _c("p", [
                                        _vm._v(
                                          "The school will no longer be able to use their current password to login."
                                        )
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "The new password will be displayed here for you to copy & paste."
                                        )
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.sendPasswordEmail,
                                            expression: "sendPasswordEmail"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "send-password-email"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.sendPasswordEmail
                                          )
                                            ? _vm._i(
                                                _vm.sendPasswordEmail,
                                                null
                                              ) > -1
                                            : _vm.sendPasswordEmail
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.sendPasswordEmail,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.sendPasswordEmail = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.sendPasswordEmail = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.sendPasswordEmail = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "send-password-email" }
                                        },
                                        [
                                          _vm._v(
                                            "also send the new password in an email to the school contact"
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-end"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-success",
                                              attrs: {
                                                disabled: _vm.isResetting
                                              },
                                              on: {
                                                click:
                                                  _vm.handleResetPasswordContinue
                                              }
                                            },
                                            [_vm._v("Continue")]
                                          )
                                        ]
                                      )
                                    ])
                                  : _c("div", [
                                      _c("p", { staticClass: "text-center" }, [
                                        _c("b", [_vm._v("New Password")])
                                      ]),
                                      _c("input", {
                                        staticClass:
                                          "form-control font-monospace",
                                        attrs: { type: "text", readonly: "" },
                                        domProps: { value: _vm.newPassword }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-end mt-4"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-primary",
                                              on: {
                                                click: function($event) {
                                                  _vm.showConfirmationModal[
                                                    "reset-password"
                                                  ] = false
                                                }
                                              }
                                            },
                                            [_vm._v("Close")]
                                          )
                                        ]
                                      )
                                    ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2150824090
                      )
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        on: {
                          click: function($event) {
                            return _vm.modal.show("deleteOrg")
                          }
                        }
                      },
                      [_vm._v("Delete school")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }